import React from 'react';
import PropTypes from 'prop-types';
import {  SearchForm } from '../../components/search-form';
import { format } from 'date-fns';
import ObjectField from '../../components/object-field';
import {RegionSelectGrouped} from "../../components/MaterialSelects/RegionSelectGrouped";
import {BoroughSelect} from "../../components/MaterialSelects/BoroughSelect";
import {DistributorSelect} from "../../components/MaterialSelects/DistributorSelect";
import {SiteTagSelect} from "../../components/MaterialSelects/SiteTagSelect";
import {SiteStructureSelect} from "../../components/MaterialSelects/SiteStructureSelect";
import {TextField} from '@mui/material';
import {NumberField} from "../../components/number-input";
import {PanelPackSelect} from "../../components/MaterialSelects/PanelPackSelect";
import {RegionTypeSelect} from "../../components/MaterialSelects/RegionTypeSelect";
import {PostcodeAreaSelect} from "../../components/MaterialSelects/PostcodeAreaSelect";
import {PanelAvailabilityStatusSelect} from "../../components/MaterialSelects/PanelAvailabilityStatusSelect";
import {PanelBookingStatusSelect} from "../../components/MaterialSelects/PanelBookingStatusSelect";
import { SiteStructureGroupSelect } from '../../components/MaterialSelects/SiteStructureGroupSelect';


interface PanelBookingsSearchProps {
  isOpen?: boolean;
  onCancel: () => void;
  params?: any[];
  onSearch: (fields: any, date: string) => void;
  date: Date;
}

class PanelBookingsSearch extends React.Component<PanelBookingsSearchProps> {
  static propTypes = {
    isOpen: PropTypes.bool,
    onCancel: PropTypes.func.isRequired,
    params: PropTypes.array.isRequired,
    onSearch: PropTypes.func.isRequired
  };
  static fieldTypes = [
    {
      label: 'Region', id: 'region',
      default: true,
      variants: [
        {
          default: true,
          id: 'in',
          multi: true,
          label: 'Lookup',
          getValue: (e) => e ? e.id : undefined,
          editor: ({ input }) => <RegionSelectGrouped panelOnly={true} multiple={true} {...input} valueIsId={true} />
        },
      ]
    }, {
      label: 'Borough', id: 'borough',
      variants: [
        {
          id: 'in', multi: true,
          label: 'Lookup',
          getValue: (e) => e ? e.id : undefined,
          editor: ({ input }) => <BoroughSelect valueIsId={true} multiple={true} {...input} />
        },
      ]
    },
    {
      label: 'Campaign Name', id: 'campaign',
      variants: [{
        id: 'like',
        label: 'Like',
        editor: ({ input }) => <TextField {...input} label="Campaign Name" />
      }
      ]
    }, {
      label: 'Site Name', id: 'site_name',
      variants: [{
        id: 'like',
        label: 'Like',
        editor: ({ input }) => <TextField {...input} placeholder="Site Name" />
      }
      ]
    }, {
      label: 'Distributor', id: 'distributor',
      variants: [
        {
          id: 'in', multi: true,
          label: 'Lookup',
          getValue: (e) => e ? e.id : undefined,
          editor: ({ input }) => <DistributorSelect multiple={true} {...input}  />
        }
      ]
    },{
      label: 'Site Tags', id: 'site_tags',
      variants: [
        {
          id: 'in', multi: true,
          label: 'Lookup',
          getValue: (e) => e ? e.id : undefined,
          editor: ({ input }) => <SiteTagSelect multiple={true} {...input} valueIsId={true} />
        }
      ]

    }, {
      label: 'Site Structure', id: 'site_structure',
      variants: [{
        id: 'in', multi: true,
        label: 'Lookup',
        getValue: (e) => e ? e.id : undefined,
        editor: ({ input }) => <SiteStructureSelect hideDigitalGroup={true} multiple={true} {...input} />
      },{
        id: 'like',
        label: 'Like',
        editor: ({ input }) => <TextField {...input} label="Structure Name"/>
      },{
        id: 'group', multi: true,
        label: 'Group',
        getValue: (e) => e ? e.id : undefined,
        editor: ({ input })=> <SiteStructureGroupSelect valueIsId={true} multiple={true} {...input} label="Structure Group"/>
      }]
    }, {
      label: 'Panel Availability Status', id: 'panel_search_type',
      variants: [
        {
          id: 'c', 
          label: 'Lookup',
          setValue:(e)=> {
            const obj: {status: string, weeks: string | number} = {status: 'empty', weeks: 1};
            const p = e.split(',');
            p.forEach((v)=>{
              const vp = v.split('-', 2);
              obj[vp[0]==='s'?'status':'weeks'] = vp[1];
            });
            return obj;
          },
          getValue: (e) => { 
            return 's-'+(e.status?e.status:'empty')+',w-'+(e.weeks?e.weeks:1);
          },
          editor: ({ input }) => <ObjectField blank={{status:'empty',weeks:1}} {...input}>{(input)=> {
          return (<>
            <PanelBookingStatusSelect {...input} valueIsId={true} value={input.value.status} name="status" className="grid12-3" label="Status"/>
            <NumberField  {...input} name="weeks" value={input.value.weeks} className="grid12-2" label="Weeks"/></>);
            }
          }
          </ObjectField>
        }
      ]
    }
    , {
      label: 'Panel Booking Status', id: 'status',
      variants: [
        {
          id: 'in', multi: true,
          label: 'Lookup',
          getValue: (e) => { return e; },
          editor: ({ input }) => <PanelAvailabilityStatusSelect valueIsId={true} multiple={true} {...input} label="Status" />
        }
      ]
    }, {
      label: 'Panel Number', id: 'panel',
      variants: [
        {
          id: 'exact',
          label: 'Exact',
          editor: ({ input }) => {
            return (<TextField {...input} label="Number"/>);
          }
        }
      ]
    }, {
      label: 'Pack type', id: 'pack',
      variants: [
        {
          id: 'in', multi: true,
          label: 'Lookup',
          getValue: (e) => e ? e.id : undefined,
          editor: ({ input }) => {
            return (<PanelPackSelect valueIsId={true} multiple={true} {...input} label="Pack Type"/>);
          }
        },
        {
          id: 'not', multi: true,
          label: 'Not including',
          getValue: (e) => e ? e.id : undefined,
          editor: ({ input }) => {
            return (<PanelPackSelect valueIsId={true} multiple={true} {...input} label="Pack Type"/>);
          }
        }
      ]
    }, {
      label: 'Region Type', id: 'region_type',
      variants: [
        {
          id: 'in', multi: true,
          label: 'Lookup',
          getValue: (e) => e ? e.id : undefined,
          editor: ({ input }) => {
            return (<RegionTypeSelect multiple={true} {...input} label="Region Type"/>);
          }
        }
      ]
    }, {
      label: 'Postcode', id: 'postcode',
      variants: [{
        id: 'rlike',
        label: 'Lookup',
        clearOnChange: false,
        getValue: (val) => {
          return val?.id;
        },
        editor: ({ input }) => <PostcodeAreaSelect {...input} label="Area"/>
      }, {
        id: 'prefix',
        label: 'Starts with',
        clearOnChange: false,
        getValue: (val) => {
          return val;
        },
        editor: ({ input }) => <TextField {...input} label="Prefix" />
      }]
    }
  ];
  render() {
    return <SearchForm onCancel={this.props.onCancel} onSearch={(v) => {
      this.props.onSearch(v, format(this.props.date, 'yyyy-MM-dd'));
    }} isOpen={this.props.isOpen}
      params={this.props.params}
      fieldTypes={PanelBookingsSearch.fieldTypes}
      name="panel-bookings"
      label="Panel Bookings "
    />
  }
}

export default PanelBookingsSearch;
